import React from 'react';

export type TabType = 'profile' | 'documents';

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tabId: TabType) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="border-b">
      <nav className="flex" aria-label="Tabs">
        <button
          onClick={() => onTabChange('profile')}
          className={`px-4 py-3 text-sm font-medium ${
            activeTab === 'profile'
              ? 'border-b-2 border-blue-500 text-blue-600'
              : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}
          aria-current={activeTab === 'profile' ? 'page' : undefined}
        >
          Profile
        </button>
        <button
          onClick={() => onTabChange('documents')}
          className={`px-4 py-3 text-sm font-medium ${
            activeTab === 'documents'
              ? 'border-b-2 border-blue-500 text-blue-600'
              : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}
          aria-current={activeTab === 'documents' ? 'page' : undefined}
        >
          Documents
        </button>
      </nav>
    </div>
  );
};

export default TabNavigation;
